import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationPayload,
  MutationTree,
} from "vuex";
import { RootState } from "../store";

export class ListPickerState {
  isOpen = false;
  modal = "";
  isAllowedToClose = false;
  selectedItems: any[] = [];
  allowMultiple = true;
  rule: ((item: any) => boolean) | null = null;
  filterBy = "";
  items: any[] = [];
}

const state: ListPickerState = new ListPickerState();

const mutations: MutationTree<ListPickerState> = {
  SET_VISIBILITY(state: ListPickerState, isOpen: boolean): void {
    state.isOpen = isOpen;
  },
  SET_MODAL(state: ListPickerState, modal: string): void {
    state.modal = modal;
  },
  SET_SELECTED_ITEMS(state: ListPickerState, selectedItems: any[]): void {
    state.selectedItems = selectedItems;
  },
  SET_ALLOW_MULTIPLE(state: ListPickerState, allowMultiple: boolean): void {
    state.allowMultiple = allowMultiple;
  },
  SET_RULE(state: ListPickerState, rule: (item: any) => boolean): void {
    state.rule = rule || null;
  },
  SET_FILTER_BY(state: ListPickerState, filterBy: string): void {
    state.filterBy = filterBy;
  },
  SET_ITEMS(state: ListPickerState, items: any[]): void {
    state.items = items;
  },
  SET_PERMISSION_TO_CLOSE(
    state: ListPickerState,
    isAllowedToClose: boolean
  ): void {
    state.isAllowedToClose = isAllowedToClose;
  },
};

const actions: ActionTree<ListPickerState, RootState> = {
  async open(
    ctx: ActionContext<ListPickerState, RootState>,
    payload: {
      modal: string;
      items: any[];
      selected: any[];
      allowMultiple?: boolean;
      rule?: (item: any) => boolean;
      filterBy: string;
    }
  ): Promise<any[]> {
    ctx.commit("SET_ITEMS", payload.items);
    ctx.commit("SET_SELECTED_ITEMS", payload.selected);
    ctx.commit("SET_ALLOW_MULTIPLE", payload.allowMultiple);
    ctx.commit("SET_RULE", payload.rule);
    ctx.commit("SET_MODAL", payload.modal);
    ctx.commit("SET_FILTER_BY", payload.filterBy);
    ctx.commit("SET_VISIBILITY", true);

    return await new Promise((resolve) => {
      this.subscribe((mutation: MutationPayload) => {
        if (mutation.type === "list_picker_module/SET_PERMISSION_TO_CLOSE") {
          if (ctx.state.isAllowedToClose) {
            ctx.commit("SET_VISIBILITY", false);
            resolve(ctx.state.selectedItems);
          }
        }
      });
    });
  },
  async save(
    { commit }: ActionContext<ListPickerState, RootState>,
    selectedItems: any[]
  ): Promise<void> {
    commit("SET_SELECTED_ITEMS", selectedItems);
    commit("SET_PERMISSION_TO_CLOSE", true);
  },
  close({ commit }: ActionContext<ListPickerState, RootState>): void {
    commit("SET_PERMISSION_TO_CLOSE", true);
  },
};

const getters: GetterTree<ListPickerState, RootState> = {
  isOpen: (state: ListPickerState): boolean => state.isOpen,
  modal: (state: ListPickerState): string => state.modal,
  items: (state: ListPickerState): any[] => state.items,
  allowMultiple: (state: ListPickerState): boolean => state.allowMultiple,
  rule: (state: ListPickerState): ((item: any) => boolean) | null => state.rule,
  filterBy: (state: ListPickerState): string => state.filterBy,
  selectedItems: (state: ListPickerState): any[] => state.selectedItems,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<ListPickerState, RootState>;
